// extracted by mini-css-extract-plugin
export var linkContainer = "link-container-module--linkContainer--5bVzg";